<template>
  <b-autocomplete
    ref="select"
    :value="selected.name"
    :data="options"
    :open-on-focus="true"
    :placeholder="`${$tc('select')} ${$tc('region')}...`"
    field="name"
    @select="onSelect"
    @typing="onSearch"
  >
    <template slot="empty">
      {{ $tc('noResult') }}
    </template>
  </b-autocomplete>
</template>
<script>
import regions from '@/assets/js/data/CO/regions'

export default {
  props: {
    value: { type: String, default: '' },
    disabled: { type: Boolean, default: false }
  },
  data() {
    return {
      options: regions
    }
  },
  computed: {
    selected: {
      get(_this) {
        if (_this.value && _this.$refs.select) {
          _this.$refs.select.setSelected(
            _this.options.find(item => item.code === _this.value)
          )
        }

        return _this.value || { name: '' }
      }
    }
  },
  mounted() {
    const _this = this
    if (_this.value && _this.$refs.select) {
      _this.$refs.select.setSelected(
        _this.options.find(item => item.code === _this.value)
      )
    }
  },
  methods: {
    onSelect(selected) {
      if (selected) {
        this.$emit('input', selected.code)
        this.$emit('set-selected', selected)
      }
    },
    onSearch(value) {
      const _this = this
      if (value) {
        _this.options = regions.filter(item =>
          item.name.toLowerCase().includes(value)
        )
      } else {
        _this.options = regions
      }
    }
  }
}
</script>
